import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

// Care Packages API. All grouping/resolution happens server-side.
const base = () => `/${getManagerRoutePath()}/domiciliary-packages`;

const domiciliaryPackagesService = {
  // view: 'client' | 'carer'
  getPackages: async (date, view = 'client') => {
    const res = await axiosInstance.get(`${base()}?view=${view}${date ? `&date=${date}` : ''}`);
    return res.data;
  },
  getPackagesWeek: async (date, view = 'client') => {
    const res = await axiosInstance.get(`${base()}/week?view=${view}${date ? `&date=${date}` : ''}`);
    return res.data;
  },
  getServiceUsers: async () => {
    const res = await axiosInstance.get(`${base()}/service-users`);
    return res.data;
  },
  getPackage: async (id) => {
    const res = await axiosInstance.get(`${base()}/${id}`);
    return res.data;
  },
  createPackage: async (payload) => {
    const res = await axiosInstance.post(`${base()}`, payload);
    return res.data;
  },
  updatePackage: async (id, payload) => {
    const res = await axiosInstance.put(`${base()}/${id}`, payload);
    return res.data;
  },
  deletePackage: async (id) => {
    const res = await axiosInstance.delete(`${base()}/${id}`);
    return res.data;
  },
};

export default domiciliaryPackagesService;
